// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Back_wrapper__BvR6X"};